// extracted by mini-css-extract-plugin
export default {"main":"Page2_main__sQH2Z","btn":"Page2_btn__JRJoP","image":"Page2_image__dBJLu"};